"use strict";

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initForm = exports.isChineseDomain = void 0;
var smartlook_1 = require("../../build-babel/form/smartlook");
var login_1 = require("../../build-babel/form/login");
var sanitizer_1 = require("../../build-babel/form/sanitizer");
var forgotPassword_1 = require("../../build-babel/form/forgotPassword");
var captchaCode_1 = require("../../build-babel/form/captchaCode");
var config_1 = require("../../build-babel/auth/client/config");
var usStates_1 = require("./usStates");
var cookieBanner_1 = require("../../build-babel/cookieBanner");
var CH_DOMAINS = ['identity.hapag-lloyd.cn', 'identity-qa-cn.hlag.cloud', 'identity-dev-cn.hlag.cloud', 'www.hapag-lloyd.cn', 'wwwtest.hapag-lloyd.cn', 'wwwdeve.hapag-lloyd.cn'];
var isChineseDomain = function isChineseDomain() {
  return CH_DOMAINS.indexOf(window.location.hostname) !== -1;
};
exports.isChineseDomain = isChineseDomain;
var isRegistrationPage = function isRegistrationPage() {
  if (document.getElementById('combinedLocation')) {
    return true;
  }
  var SUBMIT_BUTTON = document.querySelector("button[type='submit']#continue");
  if (!SUBMIT_BUTTON) {
    return false;
  }
  return getComputedStyle(SUBMIT_BUTTON).display !== 'none';
};
var isForgotPasswordPage = function isForgotPasswordPage() {
  return window.location.href.indexOf('claimsexchange=ForgotPasswordExchange') !== -1;
};
var isFinalStepOfRegistration = function isFinalStepOfRegistration() {
  return !!document.querySelector('.extension_termsOfUseConsentChoice_li');
};
var script = document.createElement('script');
script.src = config_1.cloudflare.scriptSrc;
var emailVerificationContainer = document.querySelector('.emailVerificationControl_li .attrEntry');
var emailVerificationContent = emailVerificationContainer === null || emailVerificationContainer === void 0 ? void 0 : emailVerificationContainer.querySelector('#emailVerificationControl');
var emailFieldBox = emailVerificationContainer === null || emailVerificationContainer === void 0 ? void 0 : emailVerificationContainer.querySelector('.email_li');
var emailField = emailFieldBox === null || emailFieldBox === void 0 ? void 0 : emailFieldBox.querySelector('.attrEntry');
var isVerifyEmailAddress = function isVerifyEmailAddress() {
  if (emailField) {
    var emailFieldProps = getComputedStyle(emailField);
    var display = emailFieldProps.getPropertyValue('display');
    if (display !== 'none') {
      return true;
    }
  }
  return false;
};
var useCustomerAccountType = function useCustomerAccountType() {
  var jobTitle = document.querySelector('.jobTitle_li .attrEntry');
  var newsletterConsentCheckbox = document.querySelector('.extension_newsletterConsentChoice_li');
  var accountTypes = document.querySelectorAll('input[name="accountType"]');
  if (jobTitle && newsletterConsentCheckbox) {
    newsletterConsentCheckbox.style.display = 'list-item';
    jobTitle.style.display = 'block';
    accountTypes.forEach(function (accountType) {
      accountType.addEventListener('change', function (event) {
        var item = event.target;
        if (item.value === 'customer') {
          newsletterConsentCheckbox.style.display = 'list-item';
          jobTitle.style.display = 'block';
        } else {
          var selectJobTitle = jobTitle.querySelector('#jobTitle');
          selectJobTitle.value = 'other';
          jobTitle.style.display = 'none';
          newsletterConsentCheckbox.style.display = 'none';
        }
      });
    });
  }
};
var styleAccountTypeRadioButtons = function styleAccountTypeRadioButtons() {
  var accountTypes = document.querySelector('.accountType_li .attrEntry');
  if (accountTypes) {
    // Customer account type
    var customerAccountTypeContainer = document.createElement('div');
    customerAccountTypeContainer.style.display = 'flex';
    customerAccountTypeContainer.style.marginTop = '10px';
    var customerAccountTypeInput = accountTypes.querySelector('#accountType_customer');
    customerAccountTypeInput.style.width = '25px';
    customerAccountTypeInput.style.height = '15px';
    var customerAccountTypeLabel = accountTypes.querySelector('#customer_option');
    customerAccountTypeLabel.style.margin = '0px 5px';
    accountTypes.insertBefore(customerAccountTypeContainer, customerAccountTypeInput);
    customerAccountTypeContainer.appendChild(customerAccountTypeInput);
    customerAccountTypeContainer.appendChild(customerAccountTypeLabel);
    // Vendor account type
    var vendorAccountTypeContainer = document.createElement('div');
    vendorAccountTypeContainer.style.display = 'flex';
    vendorAccountTypeContainer.style.marginTop = '10px';
    var vendorAccountTypeInput = accountTypes.querySelector('#accountType_vendor');
    vendorAccountTypeInput.style.width = '25px';
    vendorAccountTypeInput.style.height = '15px';
    var vendorAccountTypeLabel = accountTypes.querySelector('#vendor_option');
    vendorAccountTypeLabel.style.margin = '0px 5px';
    accountTypes.insertBefore(vendorAccountTypeContainer, vendorAccountTypeInput);
    vendorAccountTypeContainer.appendChild(vendorAccountTypeInput);
    vendorAccountTypeContainer.appendChild(vendorAccountTypeLabel);
  }
};
var styleFederatedExchangeButton = function styleFederatedExchangeButton() {
  var federatedExchangeButton = document.getElementById('FederatedExchange');
  if (federatedExchangeButton) {
    federatedExchangeButton.innerText = 'Log in here';
    // create a label
    var federatedExchangeLabel = document.createElement('span');
    federatedExchangeLabel.innerText = 'Hapag-Lloyd employee?';
    var federatedExchangeElement = document.createElement('div');
    federatedExchangeElement.setAttribute('id', 'FederatedExchangeContainer');
    federatedExchangeElement.classList.add('divider');
    federatedExchangeElement.appendChild(federatedExchangeLabel);
    federatedExchangeElement.appendChild(federatedExchangeButton);
    // make a place
    document.querySelectorAll('#localAccountForm .divider').forEach(function (divider) {
      return divider.remove();
    });
    // move
    var destination = document.getElementById('localAccountForm');
    destination === null || destination === void 0 ? void 0 : destination.appendChild(federatedExchangeElement);
    // remove
    var buttons = document.querySelector('.claims-provider-list-buttons');
    var nextElement = buttons === null || buttons === void 0 ? void 0 : buttons.nextElementSibling;
    nextElement && nextElement.remove();
    buttons && buttons.remove();
  }
};
var adjustAgreeOption = function adjustAgreeOption() {
  (0, exports.isChineseDomain)() ? adjustAgreeOptionForChineseDomain() : adjustAgreeOptionForAllOtherDomains();
};
var adjustAgreeOptionForChineseDomain = function adjustAgreeOptionForChineseDomain() {
  var _a, _b;
  var agreeLabel = document.getElementById('AgreeToTermsOfUseConsentYes_option');
  if (agreeLabel) {
    // create first span for 'I have read and agree to the '
    var agreeFirstSpanEnglish = document.createElement('span');
    agreeFirstSpanEnglish.innerText = 'I have read and aware of the ';
    agreeFirstSpanEnglish.setAttribute('class', 'label__agree');
    // create first span for 'I have read and agree to the '
    var agreeFirstSpanChinese = document.createElement('span');
    agreeFirstSpanChinese.innerText = '我已阅读并同意 ';
    agreeFirstSpanChinese.setAttribute('class', 'label__agree');
    // link to the Privacy Term
    var privacyTermsLinkEnglish = document.createElement('a');
    privacyTermsLinkEnglish.innerText = 'Privacy Terms';
    privacyTermsLinkEnglish.setAttribute('class', 'agree_link');
    privacyTermsLinkEnglish.setAttribute('href', 'https://www.hapag-lloyd.cn/en/meta/privacy-statement.html');
    privacyTermsLinkEnglish.setAttribute('target', '_blank');
    // link to the Privacy Term
    var privacyTermsLinkChinese = document.createElement('a');
    privacyTermsLinkChinese.innerText = '隐私条款';
    privacyTermsLinkChinese.setAttribute('class', 'agree_link');
    privacyTermsLinkChinese.setAttribute('href', 'https://www.hapag-lloyd.cn/zh/meta/privacy-statement.html');
    privacyTermsLinkChinese.setAttribute('target', '_blank');
    // create a second span for ' and '
    var agreeSecondSpanEnglish = document.createElement('span');
    agreeSecondSpanEnglish.innerText = ' and ';
    agreeSecondSpanEnglish.setAttribute('class', 'label__agree');
    // create a second span for ' and '
    var agreeSecondSpanChinese = document.createElement('span');
    agreeSecondSpanChinese.innerText = ' 和 ';
    agreeSecondSpanChinese.setAttribute('class', 'label__agree');
    // link to the Terms of Use
    var termsOfUseLinkEnglish = document.createElement('a');
    termsOfUseLinkEnglish.innerText = 'Terms of Use';
    termsOfUseLinkEnglish.setAttribute('class', 'agree_link');
    termsOfUseLinkEnglish.setAttribute('href', 'https://www.hapag-lloyd.cn/en/meta/legal-terms.html');
    termsOfUseLinkEnglish.setAttribute('target', '_blank');
    // link to the Terms of Use
    var termsOfUseLinkChinese = document.createElement('a');
    termsOfUseLinkChinese.innerText = '使用条款';
    termsOfUseLinkChinese.setAttribute('class', 'agree_link');
    termsOfUseLinkChinese.setAttribute('href', 'https://www.hapag-lloyd.cn/zh/meta/legal-terms.html');
    termsOfUseLinkChinese.setAttribute('target', '_blank');
    // create the third span for ' of the website.'
    var agreeThirdSpanEnglish = document.createElement('span');
    agreeThirdSpanEnglish.innerText = ', agree to Hapag-Lloyd, its affiliates, and authorized partners to collecting my personal data for reasonable business purposes connected to the above activity.';
    agreeThirdSpanEnglish.setAttribute('class', 'label__agree');
    // create the third span for ' of the website.'
    var agreeThirdSpanChinese = document.createElement('span');
    agreeThirdSpanChinese.innerText = '，同意赫伯罗特及其附属或关联公司和授权合作伙伴出于合理的商业目的在此处收集我的个人信息。';
    agreeThirdSpanChinese.setAttribute('class', 'label__agree');
    // create exchange english Div
    var agreeExchangeDivEnglish = document.createElement('div');
    agreeExchangeDivEnglish.appendChild(agreeFirstSpanEnglish);
    agreeExchangeDivEnglish.appendChild(privacyTermsLinkEnglish);
    agreeExchangeDivEnglish.appendChild(agreeSecondSpanEnglish);
    agreeExchangeDivEnglish.appendChild(termsOfUseLinkEnglish);
    agreeExchangeDivEnglish.appendChild(agreeThirdSpanEnglish);
    var agreeExchangeDivSpacing = document.createElement('div');
    agreeExchangeDivSpacing.setAttribute('style', 'height: 10px;');
    // create exchange english Div
    var agreeExchangeDivChinese = document.createElement('div');
    agreeExchangeDivChinese.appendChild(agreeFirstSpanChinese);
    agreeExchangeDivChinese.appendChild(privacyTermsLinkChinese);
    agreeExchangeDivChinese.appendChild(agreeSecondSpanChinese);
    agreeExchangeDivChinese.appendChild(termsOfUseLinkChinese);
    agreeExchangeDivChinese.appendChild(agreeThirdSpanChinese);
    // create exchange Label
    var agreeExchangeLabel = document.createElement('label');
    agreeExchangeLabel.setAttribute('id', 'agreeExchangeContainer');
    agreeExchangeLabel.setAttribute('for', 'extension_termsOfUseConsentChoice_AgreeToTermsOfUseConsentYes');
    agreeExchangeLabel.appendChild(agreeExchangeDivChinese);
    agreeExchangeLabel.appendChild(agreeExchangeDivSpacing);
    agreeExchangeLabel.appendChild(agreeExchangeDivEnglish);
    // replace the old agreeLabel with the new agreeExchangeLabel
    agreeLabel.replaceWith(agreeExchangeLabel);
    var secondErrorDiv = document.createElement('div');
    secondErrorDiv.setAttribute('id', 'second_tou_error');
    secondErrorDiv.setAttribute('class', 'error itemLevel');
    secondErrorDiv.setAttribute('role', 'alert');
    var secondInput = document.createElement('input');
    secondInput.setAttribute('type', 'checkbox');
    secondInput.setAttribute('id', 'extension_termsOfUseConsentChoiceSecond_AgreeToTermsOfUseConsentYes');
    var secondFirstSpanEnglish = document.createElement('span');
    secondFirstSpanEnglish.innerText = 'I agree that my data including personal information provided may be transferred and processed overseas due to business requirements connected to the above activity.';
    secondFirstSpanEnglish.setAttribute('class', 'label__agree');
    var secondFirstSpanChinese = document.createElement('span');
    secondFirstSpanChinese.innerText = '我同意此处提供的包括个人信息在内的数据因业务需要而跨境处理。';
    secondFirstSpanChinese.setAttribute('class', 'label__agree');
    var secondDivEnglish = document.createElement('div');
    secondDivEnglish.appendChild(secondFirstSpanEnglish);
    var secondDivSpacing = document.createElement('div');
    secondDivSpacing.setAttribute('style', 'height: 10px;');
    // create exchange english Div
    var secondDivChinese = document.createElement('div');
    secondDivChinese.appendChild(secondFirstSpanChinese);
    var secondLabel = document.createElement('label');
    secondLabel.setAttribute('id', 'agreeExchangeContainer');
    secondLabel.setAttribute('for', 'extension_termsOfUseConsentChoiceSecond_AgreeToTermsOfUseConsentYes');
    secondLabel.appendChild(secondDivChinese);
    secondLabel.appendChild(secondDivSpacing);
    secondLabel.appendChild(secondDivEnglish);
    var secondDiv = document.createElement('div');
    secondDiv.setAttribute('class', 'attrEntry validate');
    secondDiv.appendChild(secondErrorDiv);
    secondDiv.appendChild(secondInput);
    secondDiv.appendChild(secondLabel);
    var secondLi = document.createElement('li');
    secondLi.setAttribute('class', 'CheckboxMultiSelect extension_termsOfUseConsentChoiceSecond_li');
    secondLi.setAttribute('style', 'display: block;');
    secondLi.appendChild(secondDiv);
    var firstLi = (_a = agreeExchangeLabel.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement;
    if (firstLi) {
      (_b = firstLi.parentElement) === null || _b === void 0 ? void 0 : _b.insertBefore(secondLi, firstLi.nextSibling);
    }
  }
};
var adjustAgreeOptionForAllOtherDomains = function adjustAgreeOptionForAllOtherDomains() {
  var agreeLabel = document.getElementById('AgreeToTermsOfUseConsentYes_option');
  if (agreeLabel) {
    // create first span for 'I have read and agree to the '
    var agreeFirstSpan = document.createElement('span');
    agreeFirstSpan.innerText = 'I have read and agree to the ';
    agreeFirstSpan.setAttribute('class', 'label__agree');
    // link to the Privacy Term
    var privacyTermsLink = document.createElement('a');
    privacyTermsLink.innerText = 'Privacy Terms';
    privacyTermsLink.setAttribute('class', 'agree_link');
    privacyTermsLink.setAttribute('href', 'https://www.hapag-lloyd.com/en/meta/privacy-statement.html');
    privacyTermsLink.setAttribute('target', '_blank');
    // create a second span for ' and '
    var agreeSecondSpan = document.createElement('span');
    agreeSecondSpan.innerText = ' and ';
    agreeSecondSpan.setAttribute('class', 'label__agree');
    // link to the Terms of Use
    var termsOfUseLink = document.createElement('a');
    termsOfUseLink.innerText = 'Terms of Use';
    termsOfUseLink.setAttribute('class', 'agree_link');
    termsOfUseLink.setAttribute('href', 'https://www.hapag-lloyd.com/en/meta/legal-terms.html');
    termsOfUseLink.setAttribute('target', '_blank');
    // create the third span for ' of the website.'
    var agreeThirdSpan = document.createElement('span');
    agreeThirdSpan.innerText = ' of the website.';
    agreeThirdSpan.setAttribute('class', 'label__agree');
    // create exchange Label
    var agreeExchangeLabel = document.createElement('label');
    agreeExchangeLabel.setAttribute('id', 'agreeExchangeContainer');
    agreeExchangeLabel.setAttribute('for', 'extension_termsOfUseConsentChoice_AgreeToTermsOfUseConsentYes');
    agreeExchangeLabel.appendChild(agreeFirstSpan);
    agreeExchangeLabel.appendChild(privacyTermsLink);
    agreeExchangeLabel.appendChild(agreeSecondSpan);
    agreeExchangeLabel.appendChild(termsOfUseLink);
    agreeExchangeLabel.appendChild(agreeThirdSpan);
    // replace the old agreeLabel with the new agreeExchangeLabel
    agreeLabel.replaceWith(agreeExchangeLabel);
  }
};
var styleEmailVerificationLabel = function styleEmailVerificationLabel() {
  var list = document.querySelector('.TextBox.VerificationCode_li.VerificationCode');
  var listElement = list === null || list === void 0 ? void 0 : list.firstChild;
  var listLabel = document.createElement('label');
  listLabel.setAttribute('id', 'verificationSuccessText_Label');
  listLabel.innerHTML = 'Check your email box and paste the code you received and click Verify code';
  if (listElement) {
    listElement.appendChild(listLabel);
  }
};
var fixTabIndexes = function fixTabIndexes() {
  var FORGOT_PASSWORD_LINK_ID = 'forgotPassword';
  var link = document.getElementById(FORGOT_PASSWORD_LINK_ID);
  if (link) {
    link.setAttribute('tabIndex', '-1');
  }
};
var fixCountryCodeStyle = function fixCountryCodeStyle() {
  var countryCode = document.getElementById('inputCountryCode');
  if (countryCode) {
    countryCode.style.whiteSpace = 'initial';
  }
};
var randomizeUserRoles = function randomizeUserRoles() {
  var userRolesSelect = document.getElementById('jobTitle');
  if (userRolesSelect) {
    var userRoles = userRolesSelect.options;
    var shuffledUserRoles = _toConsumableArray(userRoles).sort(function () {
      return 0.5 - Math.random();
    });
    shuffledUserRoles.forEach(function (shuffledUserRole) {
      userRolesSelect.options.add(shuffledUserRole);
    });
  }
};
var styleSecondStepOfRegistrationPage = function styleSecondStepOfRegistrationPage() {
  var emailVerificationMessage = document.getElementById('emailVerificationControl_success_message');
  if (emailVerificationMessage) {
    var emailVerificationMessageObserver = new MutationObserver(function () {
      var successVerificationText = emailVerificationMessage === null || emailVerificationMessage === void 0 ? void 0 : emailVerificationMessage.textContent;
      var bottomSectionFields = {
        accountType: document.querySelector('.accountType_li'),
        jobTitle: document.querySelector('.jobTitle_li'),
        newPassword: document.querySelector('.newPassword_li'),
        confirmNewPassword: document.querySelector('.reenterPassword_li'),
        termsAndConditionMandatory: document.querySelector('.extension_termsOfUseConsentChoice_li'),
        additionalTermsAndConditionMandatory: document.querySelector('.extension_termsOfUseConsentChoiceSecond_li'),
        termsAndConditionOptional: document.querySelector('.extension_newsletterConsentChoice_li'),
        continueButton: document.querySelector('.buttons #continue')
      };
      if (emailVerificationMessage.style.display === 'none' || emailVerificationMessage.style.display !== 'none' && !(successVerificationText === null || successVerificationText === void 0 ? void 0 : successVerificationText.includes('The code has been verified. You can now continue.'))) {
        for (var fields in bottomSectionFields) {
          var fieldHTMLElement = bottomSectionFields[fields];
          if (fieldHTMLElement) {
            fieldHTMLElement.style.display = 'none';
          }
        }
      } else if (emailVerificationMessage.style.display !== 'none' && (successVerificationText === null || successVerificationText === void 0 ? void 0 : successVerificationText.includes('The code has been verified. You can now continue.'))) {
        for (var _fields in bottomSectionFields) {
          var _fieldHTMLElement = bottomSectionFields[_fields];
          if (_fieldHTMLElement) {
            _fieldHTMLElement.style.display = 'block';
          }
        }
      }
    });
    emailVerificationMessageObserver.observe(emailVerificationMessage, {
      attributes: true,
      childList: true,
      characterData: true
    });
  }
};
var sendVerificationCode = function sendVerificationCode() {
  var sendVerificationCodeButton = document.getElementById('emailViaMarketoVerificationControl_but_send_code');
  if (sendVerificationCodeButton) {
    sendVerificationCodeButton.click();
  }
};
var initForm = function initForm() {
  (0, login_1.removeLoginClickListener)();
  if ((0, cookieBanner_1.shouldAddCookieConsentBanner)()) {
    (0, cookieBanner_1.addCookieConsentBanner)();
  }
  sendVerificationCode();
  fixTabIndexes();
  styleFederatedExchangeButton();
  styleAccountTypeRadioButtons();
  (0, smartlook_1.initPrivacy)();
  (0, sanitizer_1.enableFormSanitization)();
  styleSecondStepOfRegistrationPage();
  if (!isForgotPasswordPage() && !isRegistrationPage()) {
    (0, login_1.addLoginClickListener)();
    (0, login_1.attachLoggedInEventListener)();
  }
  if (isForgotPasswordPage()) {
    // new password fields will be displayed back after verification code is verified successfully
    (0, forgotPassword_1.showNewPasswordFields)(false);
    var continueButton = document.getElementById('continue');
    if (continueButton) {
      continueButton.style.display = 'none';
    }
  }
  if (isRegistrationPage() && isFinalStepOfRegistration()) {
    useCustomerAccountType();
    adjustAgreeOption();
    styleEmailVerificationLabel();
  }
  if (isRegistrationPage()) {
    fixCountryCodeStyle();
    randomizeUserRoles();
    (0, usStates_1.initUsStateLogic)();
  }
  if (isVerifyEmailAddress()) {
    var emailVerifyButtonContainer = emailVerificationContent === null || emailVerificationContent === void 0 ? void 0 : emailVerificationContent.querySelector('.buttons');
    var emailVerifyContinueButton = emailVerifyButtonContainer === null || emailVerifyButtonContainer === void 0 ? void 0 : emailVerifyButtonContainer.querySelector('#emailVerificationControl_but_send_code');
    document.head.appendChild(script);
    emailVerifyContinueButton === null || emailVerifyContinueButton === void 0 ? void 0 : emailVerifyContinueButton.setAttribute('disabled', 'true');
    if (emailVerificationContent && emailVerifyButtonContainer && emailVerifyContinueButton) {
      (0, captchaCode_1.addCaptcha)(emailVerificationContent, emailVerifyButtonContainer, emailVerifyContinueButton);
    }
  }
  var emailFieldObserver = new MutationObserver(function () {
    if (emailField) {
      var style = getComputedStyle(emailField);
      var displayProps = style.getPropertyValue('display');
      if (displayProps === 'none') {
        var captchaBlock = document.querySelector('.cf-turnstile');
        if (emailVerificationContent === null || emailVerificationContent === void 0 ? void 0 : emailVerificationContent.contains(captchaBlock)) {
          emailVerificationContent.removeChild(captchaBlock);
        }
        if (document.head.contains(script)) {
          document.head.removeChild(script);
        }
      }
    }
  });
  if (emailField) emailFieldObserver.observe(emailField, {
    attributes: true,
    childList: true
  });
  if (isRegistrationPage() && isFinalStepOfRegistration()) {
    (0, login_1.addLoginNewAccountListener)();
  }
};
exports.initForm = initForm;
//# sourceMappingURL=init.js.map